
export type MarkNotificationAsFailed200SourceSourceUser = {
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  id?: number | null;
  /** @nullable */
  profileImageUrl?: string | null;
  /** @nullable */
  username?: string | null;
};
